import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

const initialState: any = {
  menuPlanReport: [],
  loading: false,
  error: null,
};

export const fetchInitiateMenuPlanReport = createAsyncThunk(
  'initialMenuPlanReport/fetchInitiateMenuPlanReport',
  async (payload) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/GetInitiateMenuPlanReport`, payload);
    return response?.data;
  }
);

const initiateMenuPlanReportSlice = createSlice({
  name: 'InitialMenuPlanReport',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInitiateMenuPlanReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInitiateMenuPlanReport.fulfilled, (state, action) => {
        state.loading = false;
        state.menuPlanReport = action.payload; // Assuming the payload is an array of menu plans
      })
      .addCase(fetchInitiateMenuPlanReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default initiateMenuPlanReportSlice.reducer;
